import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from "./Tooltip";

const Wrapper = styled.div` 
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 30px;
  user-select: none;
  transform: translate(-50%, -100%);
  background-image: url(/assets/frontend/images/elements/icon-${props => (props.type)}.svg);
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  &:hover { 
    z-index: 1; 
  }
`;

class Marker extends Component {

    static defaultProps = {};

    static propTypes = {
        item: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        showTooltip: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        onTooltipClose: PropTypes.func.isRequired
    };

    render() {
        return (
            <div>
                <Tooltip visible={this.props.showTooltip}
                         item={this.props.item}
                         type={this.props.type}
                         onClose={this.props.onTooltipClose}
                />
                <Wrapper
                    onClick={this.props.onClick}
                    {...this.props.type ? {type: this.props.type} : {}}
                />
            </div>
        );
    };
}

export default Marker;